<template>
  <div>
    <div
      class="
        flex
        items-center
        justify-between
        px-4
        py-2
        border border-gray-200
        rounded-lg
        transition-colors
      "
      :class="[
        { 'opacity-40 pointer-events-none': removing },
        user.role === 'clinician' ? 'bg-vice-light-blue' : 'bg-vice-teal-50',
      ]"
    >
      <div class="flex items-center space-x-3">
        <!-- User Avatar -->
        <img
          v-if="user.profile_photo_url"
          :src="user.profile_photo_url"
          :alt="user.name"
          class="h-10 w-10 rounded-full object-cover"
        />
        <div
          v-else
          class="h-10 w-10 rounded-full flex items-center justify-center text-white font-semibold"
          :class="user.role === 'clinician' ? 'bg-vice-medium-blue' : 'bg-vice-teal-500'"
        >
          {{ getUserInitials(user.name) }}
        </div>

        <!-- User Info -->
        <div>
          <p class="text-sm font-medium text-gray-900">{{ user.name }}</p>
          <p class="text-xs text-gray-500">{{ user.email }}</p>
          <p v-if="user.shared_at" class="text-xxs text-gray-400 mt-0.5">
            Shared {{ formatDate(user.shared_at) }}
          </p>
        </div>
      </div>

      <!-- Remove Button -->
      <button
        @click="$emit('remove', user.id)"
        :disabled="removing"
        type="button"
        class="
          inline-flex
          items-center
          px-3
          py-1.5
          border border-gray-300
          rounded-md
          text-xs
          font-medium
          text-gray-700
          bg-white
          hover:bg-gray-50
          focus:outline-none
          focus:ring-2 focus:ring-offset-2 focus:ring-vice-teal-500
          disabled:opacity-40
          disabled:cursor-not-allowed
        "
      >
        Remove
      </button>
    </div>
    <div v-if="removing" class="relative bottom-11 flex px-auto w-full">
      <ViceLoader
        colorClass="text-vice-teal-700"
        class="inset-0 flex items-center ml-3 w-full justify-center z-20"
        size="h-8 w-8"
      />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import ViceLoader from '@/Components/Loaders/ViceLoader.vue';

export default {
  name: 'ShareableUserRow',
  components: {
    ViceLoader,
  },
  props: {
    user: {
      type: Object,
      required: true,
    },
    removing: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['remove'],
  methods: {
    getUserInitials(name) {
      if (!name) return '??';

      const parts = name.split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },
    formatDate(date) {
      return dayjs(date).format('MMM D, YYYY');
    },
  },
};
</script>
